import { AuthFlow, AuthFlowError } from '@griply/types';
import { useMutation } from '@tanstack/react-query';
import { handleAuthError } from 'shared/services/backend-api/helpers';
import { signInWithGoogle } from 'shared/services/google';

export const useLoginUserWithGoogleMutation = () =>
  useMutation<void, AuthFlowError>({
    mutationFn: async () => {
      try {
        await signInWithGoogle();
      } catch (error) {
        throw handleAuthError(error, AuthFlow.GoogleSignIn);
      }
    },
  });
